import {
  Component,
  ChangeDetectionStrategy,
  OnDestroy,
  OnInit,
  AfterViewInit,
} from '@angular/core';
// import { TranslationService } from './modules/i18n/translation.service';
// language list
import enLang from './../assets/i18n/en.json';
import deLang from './../assets/i18n/de.json';
// import { SplashScreenService } from './_metronic/partials/layout/splash-screen/splash-screen.service';
import { Router, NavigationEnd, NavigationError } from '@angular/router';
import { Subscription } from 'rxjs';
// import { TableExtendedService } from './_metronic/shared/crud-table';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';

import { Inject } from '@angular/core'; //Eric
import { DOCUMENT } from '@angular/common'; //Eric

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  changeDetection: ChangeDetectionStrategy.Default,
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  
  constructor(
    private config: PrimeNGConfig,
    private translate: TranslateService,
    // private translationService: TranslationService,
    // private splashScreenService: SplashScreenService,
    private router: Router,
    // private tableService: TableExtendedService
    @Inject(DOCUMENT) private document: Document
  ) {
      translate.setTranslation('de', deLang);
      translate.setDefaultLang('de');

    // // register translations
    // this.translationService.loadTranslations(
    //   enLang,
    //   deLang,
    // );
  }

  ngOnInit() {
    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // clear filtration paginations and others
        // this.tableService.setDefaults();
        // hide splash screen
        // this.splashScreenService.hide();

        // scroll to top on every route change
        // window.scrollTo(0, 0);

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('page-loaded');
        }, 500);
      }
    });
    this.unsubscribe.push(routerSubscription);
  }

  useLanguage(language: string) {
    this.translate.use(language);
    this.translate.get('calendar').subscribe(res => this.config.setTranslation(res));
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  ngAfterViewInit() {
    this.loadStyle('theme-customer-active.css');
  }

  loadStyle(styleName: string) {
    const head = this.document.getElementsByTagName('head')[0];

    let themeLink = this.document.getElementById(
      'client-theme'
    ) as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = styleName;
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = `${styleName}`;

      head.appendChild(style);
    }
  }
}
